import api from "@/src/api";

const routes = require("routes.js.erb");

const createTranscription = async function({ commit }, itemId) {
  return api
    .post(routes.api_v5_transcriptions_path(), { item_id: itemId })
    .then(function(response) {
      commit("setTranscription", response.data.data.transcription);
    });
};

const getTranscription = async function({ commit }, transcriptionId){
  return api
    .get(routes.api_v5_transcription_path(transcriptionId))
    .then(function(response) {
      commit("setTranscription", response.data.data.transcription);
    });
}

const retryTranscription = async function({ commit }, transcriptionId){
  return api
    .post(routes.retry_api_v5_transcription_path(transcriptionId))
    .then(function(response) {
      commit("setTranscription", response.data.data.transcription);
    });
}

export { createTranscription, getTranscription, retryTranscription }
